$mol_view_tree2_to_js_test_ex_right_read_only_foo $mol_object
	a*? null
$mol_view_tree2_to_js_test_ex_right_read_only_bar $mol_object
	Obj $mol_view_tree2_to_js_test_ex_right_read_only_foo
		a*? => b*?
